var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBraces = function SvgBraces(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44444 4H7.55556C7.08406 4 6.63187 4.1873 6.29848 4.5207C5.96508 4.8541 5.77778 5.30628 5.77778 5.77778V10.2222C5.77778 10.6937 5.59048 11.1459 5.25708 11.4793C4.92368 11.8127 4.4715 12 4 12C4.4715 12 4.92368 12.1873 5.25708 12.5207C5.59048 12.8541 5.77778 13.3063 5.77778 13.7778V18.2222C5.77778 19.2 6.57778 20 7.55556 20H8.44444M15.5556 20H16.4444C16.9159 20 17.3681 19.8127 17.7015 19.4793C18.0349 19.1459 18.2222 18.6937 18.2222 18.2222V13.7778C18.2222 12.8 19.0222 12 20 12C19.5285 12 19.0763 11.8127 18.7429 11.4793C18.4095 11.1459 18.2222 10.6937 18.2222 10.2222V5.77778C18.2222 5.30628 18.0349 4.8541 17.7015 4.5207C17.3681 4.1873 16.9159 4 16.4444 4H15.5556",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBraces);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "braces.c62fb42f098901f8a050c2d12dea28e2.svg";